import styled, { css } from "styled-components";
import { ProgressBar } from "react-bootstrap";

export const PasswordMeter = styled(ProgressBar)`
  ${({ theme, color }) => css`
    background: ${color ? color : theme.colors.gstRed};
    height: 5px;
    width: 100%;
  `}
`;

export const PasswordLabel = styled.p`
  ${({ theme, color }) => css`
    color: ${color ? color : theme.colors.gstRed};
    text-align: right;
  `}
`;
